import styled from 'styled-components';

export const Section = styled.section`
  width: 100%;

  padding: var(--space-xxxxl) 0;

  background: var(--white);

  scroll-margin-top: 100px;

  @media screen and (max-width: 950px) {
    padding: var(--space-xxxl) 0;
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-xxl) 0;
  }
`;

export const Container = styled.div`
  width: min(100%, 1280px);

  margin: 0 auto;
`;

export const SectionHeader = styled.div`
  max-width: 820px;

  margin-bottom: var(--space-xxxl);

  @media screen and (max-width: 700px) {
    margin-bottom: var(--space-xxl);
  }
`;

export const HeaderIcon = styled.div`
  width: 52px;
  height: 52px;

  display: grid;
  place-items: center;

  margin-bottom: var(--space-l);
  padding: var(--space-s);

  border: 1px solid rgba(230, 139, 7, 0.14);
  border-radius: 50%;

  background: linear-gradient(135deg, var(--yellow1) 0%, var(--orange7) 100%);

  color: var(--orange5);

  font-size: 1.25rem;

  svg {
    display: block;
  }
`;

export const Eyebrow = styled.p`
  margin: 0 0 var(--space-xs);

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.78rem;
  font-weight: 850;

  text-transform: uppercase;
  letter-spacing: 0.14em;
`;

export const Title = styled.h2`
  max-width: 760px;

  margin: 0;

  color: var(--grey7);

  /* font-size: clamp(2.2rem, 4.5vw, 4rem); */
  font-size: 48px;
  line-height: 1.03;
  font-weight: 800;

  letter-spacing: -0.04em;

  @media screen and (max-width: 600px) {
    /* font-size: clamp(2rem, 11vw, 3rem); */
    font-size: clamp(1.9rem, 8vw, 2.8rem);
  }
`;

export const Description = styled.p`
  max-width: 700px;

  margin: var(--space-m) 0 0;

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 1rem;
  line-height: 1.8;
  font-weight: 500;

  @media screen and (max-width: 600px) {
    font-size: 0.95rem;
    line-height: 1.7;
  }
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: var(--space-xxxl);
  align-items: start;

  @media screen and (max-width: 950px) {
    grid-template-columns: 1fr;
    gap: var(--space-xxl);
  }
`;

export const FaqList = styled.div`
  display: grid;
  gap: var(--space-s);
`;

export const FaqItem = styled.article`
  overflow: hidden;

  border: 1px solid
    ${({ $open }) => ($open ? 'rgba(234, 154, 38, 0.38)' : 'var(--grey1)')};

  border-radius: var(--borderRadius);

  background: var(--white);

  box-shadow: ${({ $open }) =>
    $open ? 'var(--shadow-sm)' : 'var(--shadow-xs)'};

  transition:
    border-color 180ms ease,
    box-shadow 180ms ease;
`;

export const FaqButton = styled.button`
  width: 100%;
  min-height: 76px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-l);

  padding: var(--space-l);

  border: 0;

  background: transparent;
  color: var(--grey7);

  text-align: left;

  cursor: pointer;

  &:hover {
    background: rgba(255, 240, 194, 0.16);
  }

  &:focus-visible {
    outline: 3px solid var(--yellow3);
    outline-offset: -4px;
  }

  @media screen and (max-width: 600px) {
    min-height: 68px;

    gap: var(--space-m);

    padding: var(--space-m);
  }
`;

export const QuestionGroup = styled.span`
  min-width: 0;

  display: flex;
  align-items: center;
  gap: var(--space-m);
`;

export const QuestionNumber = styled.span`
  flex-shrink: 0;

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.82rem;
  line-height: 1;
  font-weight: 850;

  letter-spacing: 0.08em;
`;

export const Question = styled.span`
  color: var(--grey7);

  font-size: clamp(1rem, 1.5vw, 1.15rem);
  line-height: 1.35;
  font-weight: 800;

  letter-spacing: -0.015em;
`;

export const ChevronIcon = styled.span`
  width: 34px;
  height: 34px;

  flex-shrink: 0;

  display: grid;
  place-items: center;

  border: 1px solid
    ${({ $open }) => ($open ? 'rgba(230, 139, 7, 0.16)' : 'var(--grey1)')};

  border-radius: 50%;

  background: ${({ $open }) => ($open ? 'var(--yellow1)' : 'var(--grey15)')};

  color: ${({ $open }) => ($open ? 'var(--orange5)' : 'var(--grey5)')};

  font-size: 1rem;

  transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'rotate(0deg)')};

  transition:
    transform 180ms ease,
    background-color 180ms ease,
    border-color 180ms ease,
    color 180ms ease;

  svg {
    display: block;
  }
`;

export const AnswerWrapper = styled.div`
  display: grid;

  grid-template-rows: ${({ $open }) => ($open ? '1fr' : '0fr')};

  visibility: ${({ $open }) => ($open ? 'visible' : 'hidden')};

  transition:
    grid-template-rows 220ms ease,
    visibility 220ms ease;
`;

export const AnswerInner = styled.div`
  min-height: 0;

  overflow: hidden;
`;

export const Answer = styled.p`
  margin: 0;

  padding: 0 var(--space-l) var(--space-l) calc(var(--space-l) + 2.3rem);

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.92rem;
  line-height: 1.75;
  font-weight: 500;

  @media screen and (max-width: 600px) {
    padding: 0 var(--space-m) var(--space-m) var(--space-m);

    font-size: 0.9rem;
    line-height: 1.7;
  }
`;

export const ContactCard = styled.aside`
  position: sticky;
  top: 110px;

  padding: var(--space-xl);

  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: var(--borderRadiusLarge);

  background: linear-gradient(145deg, var(--grey7) 0%, var(--grey6) 100%);

  box-shadow: var(--shadow-lg);

  @media screen and (max-width: 950px) {
    position: relative;
    top: auto;

    width: min(100%, 680px);
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-l);
  }
`;

export const ContactTitle = styled.h3`
  margin: 0;

  color: var(--white);

  font-size: clamp(1.7rem, 3vw, 2.4rem);
  line-height: 1.08;
  font-weight: 800;

  letter-spacing: -0.035em;
`;

export const ContactDescription = styled.p`
  margin: var(--space-m) 0 0;

  color: var(--grey1);

  font-family: var(--mainFont);
  font-size: 0.9rem;
  line-height: 1.7;
  font-weight: 500;
`;

export const ContactList = styled.ul`
  display: grid;
  gap: var(--space-s);

  margin: var(--space-xl) 0 0;
  padding: 0;

  list-style: none;
`;

export const ContactListItem = styled.li`
  min-width: 0;

  display: flex;
  align-items: flex-start;
  gap: var(--space-s);

  color: var(--white);

  font-family: var(--mainFont);
  font-size: 0.85rem;
  line-height: 1.55;
  font-weight: 500;
  span {
    color: var(--white);
  }
`;

export const ContactCheck = styled.span`
  width: 22px;
  height: 22px;

  flex-shrink: 0;

  display: grid;
  place-items: center;

  margin-top: 0.05rem;

  border-radius: 50%;

  background: var(--yellow4);
  color: var(--grey7);

  font-size: 0.68rem;
  font-weight: 900;
`;

export const ContactButton = styled.a`
  width: 100%;
  min-height: 50px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-s);

  margin-top: var(--space-xl);
  padding: 0.95rem 1.35rem;

  border: 1px solid var(--yellow4);
  border-radius: var(--borderRadiusButton);

  background: var(--yellow4);
  color: var(--grey7);

  box-shadow: var(--shadow-xs);

  font-family: var(--mainFont);
  font-size: 0.9rem;
  line-height: 1;
  font-weight: 800;
  text-align: center;
  text-decoration: none;

  transition:
    transform 180ms ease,
    background-color 180ms ease,
    border-color 180ms ease,
    box-shadow 180ms ease;

  &:hover {
    transform: translateY(-2px);

    border-color: var(--white);

    background: var(--white);

    box-shadow: var(--shadow-sm);
  }

  &:focus-visible {
    outline: 3px solid var(--yellow3);
    outline-offset: 4px;
  }
`;

export const ButtonIcon = styled.span`
  flex-shrink: 0;

  display: grid;
  place-items: center;

  transition: transform 180ms ease;

  svg {
    display: block;
  }

  ${ContactButton}:hover & {
    transform: translateX(3px);
  }
`;
